import {
  isValidPageSizeOption,
  isValidSortKey,
  PageSizeOption,
  SortDirection,
  SortKey,
  stringAsSortDirection,
  UIFilters,
} from './types'

import {
  decodeFromURLParams,
  encodeToURLParams,
  UIFilterConverters,
  URLStateConverter,
} from '../filter-state-to-url-params'

type ExploreResultQueryParams = {
  pageSize?: PageSizeOption
  sortDir?: SortDirection
  sort?: SortKey
  currentPage?: number
}

const paramToInt = (v?: string): number | undefined => {
  const int = v ? parseInt(v) : undefined
  return !int || isNaN(int) ? undefined : int
}

export type ExploreTableState = ExploreResultQueryParams & UIFilters
const ExploreTableStateConverters: {
  [TKey in keyof ExploreTableState]-?: URLStateConverter<ExploreTableState[TKey]>
} = {
  ...UIFilterConverters,
  pageSize: {
    encode: (v) => (v !== undefined ? v.toString() : undefined),
    decode: (v?: string[]) => {
      if (v?.length !== 1) return
      const val = parseInt(v[0])
      if (isValidPageSizeOption(val)) return val
      return
    },
  },
  currentPage: {
    encode: (v) => (v !== undefined ? v.toString() : undefined),
    decode: (v?: string[]) => paramToInt(v?.[0]),
  },
  sortDir: {
    encode: (v) => v?.toString(),
    decode: (v?: string[]) => stringAsSortDirection(v?.[0]),
  },
  sort: {
    encode: (v) => v?.toString(),
    decode: (v?: string[]) => {
      if (!isValidSortKey(v?.[0])) return
      return v?.[0]
    },
  },
}

export const decodeExploreStateParams = (params: URLSearchParams): ExploreTableState => {
  return decodeFromURLParams(params, ExploreTableStateConverters)
}
export const encodeExploreState = (state: ExploreTableState, initialParams?: URLSearchParams): URLSearchParams => {
  return encodeToURLParams(state, ExploreTableStateConverters, initialParams)
}
